import image1 from '../images/navbar/TOP_01.jpg';
import image2 from '../images/navbar/TOP_02.jpg';
import image3 from '../images/navbar/TOP_03.jpg';

const previewCourses = [
	{
		backgroundImage: image1,
		number: '01',
		course: 'Máster en ZBRUSH',
		url: 'https://libel.academy/master-personajes-para-videojuegos',
	},
	{
		backgroundImage: image2,
		number: '02',
		course: 'Blender para Impresión 3D',
		url: 'https://libel.academy/impresion-3d-con-blender',
	},
	{
		backgroundImage: image3,
		number: '03',
		course: 'Máster en Blender',
		url: 'https://libel.academy/master-blender',
	},
];

export default previewCourses;
